import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202512: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202512",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-12-01",
  endDate: "2025-12-31",
  impressions: 12763,
  clicks: 216,
  adsSpendDollars: 1054,
  budgetDollars: 14500,
  salesDollars: 12993,
  bestEstimateRoas: 12.33,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.07,
  newCustomersAcquired: 16,
  dataAvailableAtDate: "2026-01-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
